import { render, staticRenderFns } from "./T1HotelBrakOfert.vue?vue&type=template&id=0afa9275&scoped=true&"
var script = {}
import style0 from "./T1HotelBrakOfert.vue?vue&type=style&index=0&id=0afa9275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa9275",
  null
  
)

export default component.exports